<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
    >
    <side-drawer></side-drawer>
    </v-navigation-drawer>

    <v-toolbar
      app
      color="primary"
      class="elevation-1"
    >
      <v-toolbar-side-icon @click.stop="drawer = !drawer" class="white--text"></v-toolbar-side-icon>
      <v-spacer></v-spacer>
      <v-toolbar-title class="white--text">My Store Help</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-content>
      <v-container fluid>
        <v-layout row wrap>
          <v-flex>
            <v-container  fluid grid-list-xl >
              <v-layout justify-start row wrap>
                <v-flex>
                  <h2  class="subheading font-weight-medium">
                      My Store section contains the Transactions list. This is where all the purchases will go. It is listed from oldest to the latest.
                  </h2>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>

  </div>
</template>

<script>

import SideDrawer from '@/components/SideDrawer.vue'

export default {
  data () {
    return {
      drawer: false
    }
  },
  components: {
    SideDrawer
  },
  mounted () {
    this.openDrawerForDesktop()
  }
}
</script>

<style scoped>

.round-number {
  border-radius: 50%;
  width: 30px;
  height: 30px;
  background-color: #ff0000;
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
  padding-top: 3px;
}

</style>
